import { useMemo } from 'react';
import { useUser } from './use-user';

export type Establishment = {
	id: number;
	name: string;
	company: {
		id: number;
	};
};
const useEstablishments = () => {
	const { activeCompany, isSchoolAdmin, isSchoolSuperUser, profile } = useUser();

	return useMemo(() => {
		if (isSchoolAdmin || isSchoolSuperUser) {
			return activeCompany.establishments;
		}

		const establishments = profile.companyContactPerson.establishments as Establishment[];
		return establishments.filter((establishment) => establishment.company.id === activeCompany.id);
	}, [isSchoolSuperUser, isSchoolAdmin, activeCompany, profile]);
};

export default useEstablishments;
